import React from "react";
import { observer } from "mobx-react";
import { SignedContractViewStore } from "../../store";
import { SignedContractViewForm } from "./SignedContractViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type SignedContractViewProps = {
  signedContractViewStore: SignedContractViewStore;
};

export const SignedContractView: React.FC<SignedContractViewProps> = observer(
  ({ signedContractViewStore }) => {
    return (
      <div>
        <SignedContractViewForm
          data_={signedContractViewStore.data_Value}
          recordId={signedContractViewStore.signedContractInstance?.id || ""}
          onPrint={(handlePrint: () => void) =>
            signedContractViewStore.printSignedContract(handlePrint)
          }
          onCancel={() => signedContractViewStore.cancelSignedContract()}
          onEdit={
            signedContractViewStore.isEditEnabled
              ? () => signedContractViewStore.editSignedContract()
              : undefined
          }
        />
        <ErrorDialog
          open={signedContractViewStore.errorDialogOpened}
          title={signedContractViewStore.errorTitle}
          description={signedContractViewStore.errorDescription}
          onClose={() => signedContractViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
